module.exports = __webpack_public_path__ + "img/cover-akfel-wgc-paris-multitouch-application.9c5906e0.jpg";